export const designationOptions = [
  { value: 7, label: 'Branch Admin' },
  { value: 8, label: 'HR Head' },
  { value: 9, label: 'Hr-Personnel' },
  { value: 11, label: 'Subject Matter Expert' },
  { value: 12, label: 'Internal Candidate' },
  { value: 13, label: 'External Candidate' },
]
export const designationOptionsSub = [
  { value: 9, label: 'Hr-Personnel' },
  { value: 11, label: 'Subject Matter Expert' },
  { value: 12, label: 'Internal Candidate' },
  { value: 13, label: 'External Candidate' },
]
// INFO: Roles in the corporate portal
// const userRole = {
//   CORPORATE_ADMIN: 'corporate-admin',
//   BRANCH_ADMIN: 'branch-admin',
//   HR_HEAD: 'hr-head',
//   HR_PERSONNEL: 'hr-personnel',
//   MANAGER: 'manager',
//   SUBJECT_MATTER_EXPERT: 'subject-matter-expert',
//   INTERNAL_CANDIDATE: 'internal-candidate',
//   EXTERNAL_CANDIDATE: 'external-candidate',
// }
const userRole = {
  CORPORATE_ADMIN: 'Corporate Admin',
  BRANCH_ADMIN: 'Branch Admin',
  HR_HEAD: 'HR Head',
  HR_PERSONNEL: 'Hr-Personnel',
  MANAGER: 'Manager',
  SUBJECT_MATTER_EXPERT: 'Subject Matter Expert',
  INTERNAL_CANDIDATE: 'Internal Candidate',
  EXTERNAL_CANDIDATE: 'External Candidate',
}

const allAccess = [
  userRole.CORPORATE_ADMIN,
  userRole.BRANCH_ADMIN,
  userRole.HR_HEAD,
  userRole.HR_PERSONNEL,
  userRole.MANAGER,
  userRole.SUBJECT_MATTER_EXPERT,
  userRole.INTERNAL_CANDIDATE,
  userRole.EXTERNAL_CANDIDATE,
]

// This is only for development purpose
const testUser = 'testUser'

// Functionality for conditional rendering based on role
const ShowContent = (props) => {
  const couldShow = props.contentHasAccess.includes(props.role)
  return couldShow ? props.children : null
}

// Header navigation access for role
const headerTabAccess = {
  home: [
    testUser,
    userRole.EXTERNAL_CANDIDATE,
    userRole.INTERNAL_CANDIDATE,
    userRole.HR_PERSONNEL,
    userRole.MANAGER,
    userRole.HR_HEAD,
    userRole.CORPORATE_ADMIN,
    userRole.BRANCH_ADMIN,
    userRole.SUBJECT_MATTER_EXPERT,
  ],
  batch: [testUser, userRole.HR_PERSONNEL, userRole.MANAGER, userRole.HR_HEAD],
  exam: [
    testUser,
    userRole.EXTERNAL_CANDIDATE,
    userRole.INTERNAL_CANDIDATE,
    userRole.HR_PERSONNEL,
    userRole.MANAGER,
    userRole.HR_HEAD,
    userRole.SUBJECT_MATTER_EXPERT,
  ],
  organisation: [testUser, userRole.CORPORATE_ADMIN, userRole.BRANCH_ADMIN], // See below "organisationTabAccess"
  Questionnaire: [
    testUser,
    userRole.HR_PERSONNEL,
    userRole.MANAGER,
    userRole.HR_HEAD,
  ],
  store: [testUser],
  cart: [testUser],
  notification: [
    userRole.EXTERNAL_CANDIDATE,
    userRole.INTERNAL_CANDIDATE,
    userRole.HR_PERSONNEL,
    userRole.MANAGER,
    userRole.HR_HEAD,
    userRole.CORPORATE_ADMIN,
    userRole.BRANCH_ADMIN,
    userRole.SUBJECT_MATTER_EXPERT,
  ],
  settings: {
    myProfile: [
      testUser,
      userRole.EXTERNAL_CANDIDATE,
      userRole.INTERNAL_CANDIDATE,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
      userRole.CORPORATE_ADMIN,
      userRole.BRANCH_ADMIN,
      userRole.SUBJECT_MATTER_EXPERT,
    ],
    candidateManagement: [testUser],
    paymentDetails: [testUser],
    purchaseHistory: [testUser],
    sendRegistrationInvite: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
    changePassword: [
      testUser,
      userRole.EXTERNAL_CANDIDATE,
      userRole.INTERNAL_CANDIDATE,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
      userRole.CORPORATE_ADMIN,
      userRole.BRANCH_ADMIN,
      userRole.SUBJECT_MATTER_EXPERT,
    ],
    help: [testUser],
    logout: [testUser, ...allAccess],
  },
  invitations: [userRole.EXTERNAL_CANDIDATE],
}

// Exam content and action access for role
const examTabAccess = {
  createNewExam: [
    testUser,
    userRole.HR_PERSONNEL,
    userRole.MANAGER,
    userRole.HR_HEAD,
  ],
  readyAction: [
    testUser,
    userRole.HR_PERSONNEL,
    userRole.MANAGER,
    userRole.HR_HEAD,
  ],
  upcomingAction: {
    reschedule: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
    viewCandidate: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
    viewDetails: [
      testUser,
      userRole.EXTERNAL_CANDIDATE,
      userRole.INTERNAL_CANDIDATE,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
      userRole.SUBJECT_MATTER_EXPERT,
    ],
    deleteExam: [testUser],
  },
  ongoingAction: {
    attendExam: [
      testUser,
      userRole.EXTERNAL_CANDIDATE,
      userRole.INTERNAL_CANDIDATE,
      userRole.SUBJECT_MATTER_EXPERT,
    ],
    reschedule: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
    viewCandidate: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
    viewDetails: [
      testUser,
      userRole.EXTERNAL_CANDIDATE,
      userRole.INTERNAL_CANDIDATE,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
      userRole.SUBJECT_MATTER_EXPERT,
    ],
  },
  completedAction: {
    viewCandidate: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
    viewDetails: [
      testUser,
      userRole.EXTERNAL_CANDIDATE,
      userRole.INTERNAL_CANDIDATE,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
      userRole.SUBJECT_MATTER_EXPERT,
    ],
    viewReport: [
      testUser,
      userRole.HR_PERSONNEL,
      userRole.MANAGER,
      userRole.HR_HEAD,
    ],
  },

  viewDetails_viewQuestion: [
    testUser,
    userRole.HR_PERSONNEL,
    userRole.MANAGER,
    userRole.HR_HEAD,
  ],
  viewDetails_editQuestion: [
    testUser,
    userRole.HR_PERSONNEL,
    userRole.MANAGER,
    userRole.HR_HEAD,
  ],
  viewDetails_examDetails: {
    details: {
      details_own: [testUser],
      examName: [testUser],
      examDescription: [testUser],
      examType: [testUser],
      examinationType: [testUser],
      instructions: [testUser],
    },
    schedule: {
      schedule_own: [testUser],
      examDuration: [testUser],
      examValidFrom: [testUser],
      examValidTill: [testUser],
      resultDeclarationDate: [
        testUser,
        userRole.HR_PERSONNEL,
        userRole.MANAGER,
        userRole.HR_HEAD,
      ],
    },
    allocation: {
      allocation_own: [
        testUser,
        userRole.HR_PERSONNEL,
        userRole.MANAGER,
        userRole.HR_HEAD,
      ],
      allocation: [testUser],
    },
    syllabus: {
      syllabus_own: [testUser],
      subject: [testUser],
      topics: [
        testUser,
        userRole.HR_PERSONNEL,
        userRole.MANAGER,
        userRole.HR_HEAD,
      ],
    },
    questionPaper: {
      questionPaper_own: [testUser],
      questionPaperName: [
        testUser,
        userRole.HR_PERSONNEL,
        userRole.MANAGER,
        userRole.HR_HEAD,
      ],
      visibility: [
        testUser,
        userRole.HR_PERSONNEL,
        userRole.MANAGER,
        userRole.HR_HEAD,
      ],
      evaluationMode: [testUser],
      totalQuestions: [testUser],
      scorePerQuestion: [testUser],
      passingMarks: [testUser],
      randomise: [
        testUser,
        userRole.HR_PERSONNEL,
        userRole.MANAGER,
        userRole.HR_HEAD,
      ],
    },
    questions: {
      questions_own: [
        testUser,
        userRole.HR_PERSONNEL,
        userRole.MANAGER,
        userRole.HR_HEAD,
      ],
      mode: [testUser],
      selectType: [testUser],
      difficultyDistribution: [testUser],
    },
    proctoring: {
      proctoring_own: [
        testUser,
        userRole.HR_PERSONNEL,
        userRole.MANAGER,
        userRole.HR_HEAD,
      ],
      proctoring: [testUser],
    },
  },
}

//see above "headerTabAccess > organisation"
const organisationTabAccess = {
  organisationProfile: [
    testUser,
    userRole.CORPORATE_ADMIN,
    userRole.BRANCH_ADMIN,
  ],
  employeeManagement: [
    testUser,
    userRole.CORPORATE_ADMIN,
    userRole.BRANCH_ADMIN,
  ],
  branchManagement: [testUser, userRole.CORPORATE_ADMIN],
}

const moreTabAccess = {
  jobRole: [
    testUser,
    userRole.HR_PERSONNEL,
    userRole.MANAGER,
    userRole.HR_HEAD,
  ],
}

const viewAnswerAccessInReport = [
  testUser,
  userRole.HR_PERSONNEL,
  userRole.MANAGER,
  userRole.HR_HEAD,
]

export {
  testUser,
  userRole,
  ShowContent,
  headerTabAccess,
  examTabAccess,
  allAccess,
  organisationTabAccess,
  moreTabAccess,
  viewAnswerAccessInReport,
}
